import styled from 'styled-components';

export interface IParticle {
  color: string;
  degree: number; // vector direction, between 0-360 (0 being straight up ↑)
  rotationDuration: number;
  durationChaos: number;
  x1: number;
  x2: number;
  x3: number;
  x4: number;
  y1: number;
  y2: number;
  y3: number;
  y4: number;
  isCircle: boolean;
  width: number;
  height: number;
  rotationName: string;
  confettiX: string;
  confettiY: string;
}

interface ConfettiExplosionStylesProps {
  particles: IParticle[];
}

const Container = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
`;

const Screen = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  pointer-events: none;
`;

export const ConfettiExplosionStyles: React.FC<ConfettiExplosionStylesProps> = ({ particles }) => {
  return (
    <Screen>
      <Container>
        {particles.map((particle) => (
          <Particle key={particle.confettiX} particle={particle} />
        ))}
      </Container>
    </Screen>
  );
};

type ParticleProps = {
  particle: IParticle;
};

const Particle = ({ particle }: ParticleProps) => {
  const {
    durationChaos,
    rotationName,
    width,
    height,
    isCircle,
    color,
    rotationDuration,
    x1,
    x2,
    x3,
    x4,
    y1,
    y2,
    y3,
    y4,
    confettiX,
    confettiY,
  } = particle;

  return (
    <div
      style={{
        position: 'absolute',
        left: '50%',
        bottom: 0,
        transform: 'translateX(-50%)',
        animation: `
          ${confettiX} ${durationChaos}ms forwards cubic-bezier(${x1}, ${x2}, ${x3}, ${x4}),
          ${confettiY} ${durationChaos}ms forwards cubic-bezier(${y1}, ${y2}, ${y3}, ${y4})
        `,
      }}
    >
      <div
        className={rotationName}
        style={{
          width,
          height,
          borderRadius: isCircle ? '50%' : undefined,
          animationName: rotationName,
          animationDuration: `${rotationDuration}ms`,
          animationIterationCount: 'infinite',
          animationTimingFunction: 'linear',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div
          style={{
            width: '100%',
            height: '100%',
            backgroundColor: color,
          }}
        />
      </div>
    </div>
  );
};
